/**
 * Shared "am I inside the native mobile app / installed PWA?" detection.
 *
 * Used to switch subtle UX (e.g. skip the marketing Landing, show a
 * connectivity banner, adjust safe-area padding) without duplicating the
 * detection logic across components.
 *
 * We treat all three of these as "native/installed":
 *   - CSSOM display-mode: standalone  (Android Chrome installed PWA)
 *   - CSSOM display-mode: minimal-ui  (some launchers)
 *   - navigator.standalone === true   (iOS Safari home-screen)
 *
 * Emergent's native mobile shell also renders in standalone display-mode, so
 * this covers the "app on the App Store" case too.
 */

export function isStandalone() {
    try {
        if (window.matchMedia?.("(display-mode: standalone)").matches) return true;
        if (window.matchMedia?.("(display-mode: minimal-ui)").matches) return true;
        if (window.navigator?.standalone === true) return true;
    } catch { /* SSR / private mode / etc. */ }
    return false;
}

export function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
